/* AISEN — Calculadora de dreno de câmara fria. Web Component vanilla, sem React.
   Lógica espelha o módulo fonte C:\dev-env\aisen-calculadoras/src/dreno (+ comum/eletrica). */
(() => {
  const CFG = {
    sobraEntrada: 0.3, // interna: descida da bandeja / tê de entrada
    margemExterna: 1.1, // externa: +10%
    terminalFrio: 1.0, // 1 ponta
    passo: 1, minM: 1, maxM: 50,
    tensaoPadrao: 220, pedidoMin: 500,
    diametroMin: '3/4',
    diametros: ['1/2', '3/4', '1', '1.1/4', '1.1/2', '2'],
    // temp → W/m (dreno só 30/40/50)
    tabela: [[-19, 30], [-29, 40], [-Infinity, 50]],
    limComprimentoIncomum: 30, correnteMax: 10,
  };

  const round = (x, dp) => { const f = 10 ** dp; return Math.round(x * f) / f; };
  const brl = (n) => n.toLocaleString('pt-BR');

  function calcularDreno(e) {
    if (!(e.comprimento > 0)) throw new Error('O comprimento do trecho frio deve ser maior que zero.');
    if (![127, 220, 380].includes(e.tensao)) throw new Error('Tensão inválida.');

    const alertas = [];
    const inst = e.instalacao === 'externa' ? 'externa' : 'interna';
    const aquecido = inst === 'externa'
      ? e.comprimento * CFG.margemExterna
      : e.comprimento + CFG.sobraEntrada;
    let total = Math.ceil((aquecido + CFG.terminalFrio) / CFG.passo) * CFG.passo;
    total = Math.max(total, CFG.minM);
    const degrau = CFG.tabela.find(([t]) => e.temp >= t)[1];
    const potencia = degrau * aquecido;

    const r = {
      instalacao: inst, comprimentoTotal: total, degrau, potencia: round(potencia, 1),
      pedidoEspecial: e.tensao !== CFG.tensaoPadrao, passagem: 'nao_informado', alertas,
    };

    if (e.tensao === CFG.tensaoPadrao) {
      r.resistencia = round((220 * 220) / potencia, 1);
      r.corrente = round(potencia / 220, 2);
    } else {
      alertas.push(`Fabricamos em ${e.tensao} V somente sob encomenda, para pedidos a partir de ${CFG.pedidoMin} metros. Fale com nosso comercial.`);
    }

    if (inst === 'interna') {
      if (e.diametro) {
        const idx = CFG.diametros.indexOf(e.diametro), minIdx = CFG.diametros.indexOf(CFG.diametroMin);
        if (idx >= 0 && idx < minIdx) {
          r.passagem = 'apertado';
          alertas.push(`Em tubo de ${e.diametro}" o cabo compromete o escoamento do degelo. Recomendamos tubo de ${CFG.diametroMin}" ou maior, ou a instalação externa.`);
        } else r.passagem = 'ok';
      }
    } else {
      alertas.push('Fixe o cabo colado ao tubo em todo o percurso com fita de alumínio — o contato contínuo é o que transfere o calor para o tubo.');
      alertas.push('Cubra tubo + cabo com isolamento térmico (espuma elastomérica). Sem isolamento, o calor se perde para o ar da câmara e o dreno pode congelar mesmo com a resistência ligada.');
    }

    if (e.temp > 0) alertas.push('Em câmaras de temperatura positiva o dreno normalmente não congela. Confirme se o tubo atravessa alguma área de temperatura negativa antes de comprar.');
    if (total > CFG.maxM) alertas.push('Acima de 50 m, divida em 2 circuitos (um por trecho) ou fale com nosso comercial para fabricação especial.');
    if (e.comprimento > CFG.limComprimentoIncomum) alertas.push('Confirme a medida — drenos acima de 30 m são raros; verifique se mediu só o trecho frio.');
    if (r.corrente != null && r.corrente > CFG.correnteMax) alertas.push('Corrente elevada — recomendamos dividir em 2 circuitos.');

    return r;
  }

  const numBR = (el) => {
    if (!el) return null;
    const v = String(el.value ?? '').trim().replace(',', '.');
    if (v === '') return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  };

  class AisenDrenoCalc extends HTMLElement {
    connectedCallback() {
      this.ac = new AbortController();
      const on = { signal: this.ac.signal };
      this.out = this.querySelector('[data-result]');
      this.productUrl = this.getAttribute('data-product-url') || '';
      const fields = ['comprimento', 'temp', 'tensao', 'instalacao', 'diametro'];
      this.f = {};
      fields.forEach((k) => { this.f[k] = this.querySelector(`[data-field="${k}"]`); });
      const rerun = () => this.run();
      Object.values(this.f).forEach((el) => {
        if (!el) return;
        el.addEventListener('input', rerun, on);
        el.addEventListener('change', rerun, on);
      });
      const btn = this.querySelector('[data-calc-submit]');
      if (btn) btn.addEventListener('click', (ev) => { ev.preventDefault(); this.run(); }, on);
      this.run();
    }
    disconnectedCallback() { this.ac?.abort(); }

    run() {
      if (!this.out) return;
      const comprimento = numBR(this.f.comprimento), temp = numBR(this.f.temp);
      const tensao = this.f.tensao ? Number(this.f.tensao.value) : 220; // fabricação padrão
      const instalacao = this.f.instalacao?.value || 'interna';
      // o diâmetro só vale na instalação interna — esconde na externa
      const dw = this.querySelector('[data-diametro-wrap]');
      if (dw) dw.hidden = instalacao === 'externa';
      if (comprimento == null || temp == null || !tensao) { this.out.hidden = true; return; }
      const e = {
        comprimento, temp, tensao, instalacao,
        diametro: instalacao === 'externa' ? null : this.f.diametro?.value || null,
      };
      let r;
      try { r = calcularDreno(e); } catch (err) {
        this.out.hidden = false;
        this.out.innerHTML = `<p class="aisen-pc__err">${err.message}</p>`;
        return;
      }
      this.render(r);
    }

    render(r) {
      const eletrica = r.pedidoEspecial
        ? `<div class="aisen-pc__special">Fabricação padrão é 220 V. Para <strong>${this.f.tensao.value} V</strong>, o fornecimento é sob encomenda (pedidos a partir de ${CFG.pedidoMin} m). Fale com o comercial.</div>`
        : `<div class="aisen-pc__kpi"><span>Resistência total</span><strong>${brl(r.resistencia)} Ω</strong></div>
           <div class="aisen-pc__kpi"><span>Corrente</span><strong>${brl(r.corrente)} A</strong></div>`;

      const alertas = r.alertas.length
        ? `<ul class="aisen-pc__alerts">${r.alertas.map((a) => `<li>${a}</li>`).join('')}</ul>` : '';

      const inst = r.instalacao === 'externa' ? 'Externa (por fora do tubo)' : 'Interna (dentro do tubo)';
      // só mostra o resultado do tubo quando há veredito (interna + diâmetro informado)
      const tuboKpi = r.passagem === 'nao_informado' ? ''
        : `<div class="aisen-pc__kpi"><span>Cabo no tubo</span><strong>${r.passagem === 'ok' ? '✓ Diâmetro adequado' : '⚠ Diâmetro apertado'}</strong></div>`;

      const cta = this.productUrl
        ? `<a class="aisen-pc__cta" href="${this.productUrl}">Comprar cabo para dreno ${r.degrau} W/m</a>` : '';

      this.out.hidden = false;
      this.out.innerHTML = `
        <div class="aisen-pc__headline">
          <span class="aisen-pc__eyebrow">Você precisa de aproximadamente</span>
          <strong class="aisen-pc__big">${brl(r.comprimentoTotal)} m</strong>
          <span class="aisen-pc__sub">de cabo de dreno · ${r.degrau} W/m</span>
        </div>
        <div class="aisen-pc__grid">
          <div class="aisen-pc__kpi"><span>Potência do cabo</span><strong>${r.degrau} W/m</strong></div>
          <div class="aisen-pc__kpi"><span>Potência total</span><strong>${brl(r.potencia)} W</strong></div>
          <div class="aisen-pc__kpi"><span>Consumo aprox.</span><strong>${brl(round(r.potencia / 1000 * (Number(this.getAttribute('data-consumo-horas')) || 12), 1))} kWh/dia</strong></div>
          ${eletrica}
          <div class="aisen-pc__kpi"><span>Instalação</span><strong>${inst}</strong></div>
          ${tuboKpi}
        </div>
        ${alertas}
        ${cta}
        <p class="aisen-pc__disc">Estimativa orientativa. A configuração definitiva é confirmada pela equipe técnica AISEN conforme a aplicação.</p>`;
    }
  }

  if (!customElements.get('aisen-dreno-calc')) customElements.define('aisen-dreno-calc', AisenDrenoCalc);
})();
